import httpClient from '@/lib/httpClient'
import { useQuery } from '@tanstack/react-query'

export default function useGetMoneyPaths() {
  const fetchData = async () => {
    const response = await httpClient.get(`team/money-paths`)
    return [
      ...response.data.data,
      // ...response.data.data,
      // ...response.data.data,
      // ...response.data.data,
      // ...response.data.data,
      // ...response.data.data,
      // ...response.data.data,
      // ...response.data.data,
      // ...response.data.data,
      // ...response.data.data,
    ]
  }

  return useQuery({
    queryKey: ['money-paths', 'list'],
    queryFn: fetchData,
  })
}
